import type { WidgetOptions } from '@/types'
import { logger } from '@sentry/vue'
import { readonly, ref } from 'vue'

const widgetOptions = ref<WidgetOptions>({
    inline: false,
    autoCloseWidget: false,
    customPagePreview: false,
    customPageGridEnabled: true,
    autoHeight: false,
    loading: true,
    cssConfig: {},
    allowUnpromptedWorkflowLeave: false,
})

const setOptions = (options: Partial<WidgetOptions>) => {
    logger.trace('Set widget options', options)
    widgetOptions.value = {
        ...widgetOptions.value,
        ...options,
    }
}

function useWidgetOptions() {
    return {
        options: readonly(widgetOptions),
        setOptions,
    }
}

export default useWidgetOptions
